import { Spin } from 'antd';
import styles from './styles.module.scss';

type Props = {
  tip?: string;
};

const defaultProps: Props = {
  tip: 'Loading...',
};
const Loading = (props: Props) => {
  return (
    <div className={styles.loading}>
      <Spin tip={props.tip ? props.tip : defaultProps.tip} />
    </div>
  );
};

Loading.defaultProps = defaultProps;
export default Loading;
